// Scroll a deep-linked row/card into view and briefly flash it for clarity.
export const scrollAndFlash = (testId) => {
  const el = document.querySelector(`[data-testid="${testId}"]`);
  if (!el) return false;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.add('highlight-flash');
  setTimeout(() => el.classList.remove('highlight-flash'), 2200);
  return true;
};
